var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-descriptions',[_c('a-descriptions-item',{staticStyle:{"text-align":"center"}},[_c('div',[_vm._v(" "+_vm._s(_vm.Copyright)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }